import { ImageData } from '../../core/models/imagedata.model';
import { FileData } from '../../core/models/filedata.model';

export class InfoPageCategory {
  id: number;
  isPublic: boolean;
  name: string;
  infoPages: InfoPage[];
}

export class InfoPage {
  id: number;
  contentTypeId: number;
  contentTypeName: string;
  isPublic: boolean;
  title: string;
  shortText: string;
  mainText: string;
  introText: string;
  modeifiedOn: string;
  createdOn: string;
  images: ImageData[];
  files: FileData[];
  createdBy: string;
}



// WEBPACK FOOTER //
// ./src/app/about-budget/shared/info-page.model.ts